import React from 'react';
import {Route, Routes} from 'react-router';

import {Page404} from "../../404";
import {ManyCapabilities} from "./capabilities/many";
import {ManyRoles} from "./roles/many";


const AccessPage = () => {
    return <Routes>
        <Route path="/capabilities" element={<ManyCapabilities />} />
        <Route path="/roles" element={<ManyRoles />} />
        <Route path="*" element={<Page404 />} />
    </Routes>
}

export {AccessPage};
